module.exports = __webpack_public_path__ + "img/mcx.d86ba278.png";